import 'intl-pluralrules';
import { invert } from 'lodash-es';
import FR from './assets/emoji_u1f1eb_1f1f7.svg';
import EN from './assets/emoji_u1f1ec_1f1e7.svg';
import DE from './assets/emoji_u1f1e9_1f1ea.svg';
import IT from './assets/emoji_u1f1ee_1f1f9.svg';
import ES from './assets/emoji_u1f1ea_1f1f8.svg';
import PT from './assets/emoji_u1f1f5_1f1f9.svg';
// eslint-disable-next-line import/named
import { InitOptions, createInstance } from 'i18next';
import { getJooxterLanguageSubdomain, isUserLang } from './url';
import { Lang } from '@jooxter/api';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(LocalizedFormat);

export const langMapping: {
  [key: string]: string;
} = {
  en: 'en-US',
  fr: 'fr-FR',
  de: 'de-DE',
  it: 'it-IT',
  es: 'es-ES',
  pt: 'pt-PT',
};

export const reverseLangMapping = invert(langMapping);

export const JxtI18nextOptionsFactory = {
  build(
    context: 'webapp' | 'mobile',
    env: 'staging' | 'prod' | 'development',
    infos: { version: string }
  ): InitOptions {
    const randomNumber = Math.floor(Math.random() * 1000);
    const backendUrl =
      env === 'development'
        ? `https://s3.eu-west-1.amazonaws.com/translations.jooxter.com/staging/${context}/{{lng}}.vendor.json?version=${infos.version}-${randomNumber}`
        : `https://translations.jooxter.com/${env}/${context}/{{lng}}.vendor.json?version=${infos.version}-${randomNumber}`;
    let currentLang = getJooxterLanguageSubdomain();

    if (!currentLang) {
      currentLang = isUserLang(window.navigator.language) ? window.navigator.language : Lang.En;
    }

    return {
      backend: {
        loadPath: backendUrl,
      },
      lng: langMapping[currentLang as Lang] ?? currentLang,
      fallbackLng: 'en-US',
      load: 'currentOnly',
    };
  },
};

export const JxtI18n = createInstance();

export const getLanguageList = (): Array<{ lang: Lang; label: string; icon: string }> => {
  return [
    {
      lang: Lang.En,
      label: 'lang.english',
      icon: EN,
    },
    {
      lang: Lang.Fr,
      label: 'lang.french',
      icon: FR,
    },
    {
      lang: Lang.De,
      label: 'lang.german',
      icon: DE,
    },
    {
      lang: Lang.It,
      label: 'lang.italian',
      icon: IT,
    },
    {
      lang: Lang.Es,
      label: 'lang.spanish',
      icon: ES,
    },
    {
      lang: Lang.Pt,
      label: 'lang.portuguese',
      icon: PT,
    },
  ];
};

export * from './url';
export * from './temporaryTranslations';
